import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import{ navega } from "../js/actions/index"; 	
import "./menu.scss";
import { cargaAbordaje } from "../js/actions";

function mapStateToProps(state){return{
	pagina:state.navegacion.pagina,
	usuario:state.login.user,
};}

function mapDispatchToProps(dispatch){return{
	navega: (pagina) => dispatch(navega(pagina)),
	cargaAbordaje: (caso,abordaje)=> dispatch(cargaAbordaje({caso,abordaje})),
};}
class MenuConnected extends Component{
	static propTypes = {
		pagina:PropTypes.string,
		usuario:PropTypes.object,
		navega:PropTypes.func,
		cargaAbordaje: PropTypes.func,
	}
	botones = [
		{id:"inicio",texto:"Inicio"},
		{id:"teoria",texto:"Teoría"},
		{id:"exploracion",texto:"Exploración"},
		{id:"final",texto:"Examen final"},
	]
	render(){
		let soloAtlas = (this.props.usuario.acf && this.props.usuario.acf.solo_atlas)?this.props.usuario.acf.solo_atlas:false;
		let ultimoVideoVisto = (this.props.usuario.acf && this.props.usuario.acf.videovisto)?parseInt(this.props.usuario.acf.videovisto):0;
		let ultimaExploracionVista = (this.props.usuario.acf && this.props.usuario.acf.ultima_exploracion)?parseInt(this.props.usuario.acf.ultima_exploracion):0;
		return(
			<div className="menu">
				{
					this.botones.map((item) => {
						let clase = "menuItem";
						if(item.id === "final"){
							if(soloAtlas) return null;
							if(ultimaExploracionVista < 67) clase += " off";
						}else if(item.id === "exploracion"){ 
							if(!soloAtlas && ultimoVideoVisto < 5) clase += " off";
						}else if(item.id === "teoria" && soloAtlas) return null;
						if(item.id === this.props.pagina) clase += " on";
						return <div className={clase} key={item.id} onClick={()=>{
							if(item.id === "exploracion") this.props.cargaAbordaje(-1,-1);
							this.props.navega(item.id);
						}}>{item.texto}</div>;
					})
				}
				<div className="menuItem der">{this.props.usuario.slug}</div>
				<div className="menuItem der tutor"><a href="mailto:info@vinnospain.com">Tutor</a></div>
			</div>
		);
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(MenuConnected);